import type { GiftcardCartItem } from '~/composables/types/cart'
import { Pricings } from '~/composables/types/event'

const parseGiftcardWithoutEvent = (
  pricings: Pricings,
  name: string,
  supplierId: string | undefined | null,
  id?: string,
  supplierName?: string
): GiftcardCartItem => {
  return {
    type: 'GIFT_CARD',
    giftcardType: 'VALUE',
    giftcardAddon: 'PDF',
    title: name || 'Giftcard',
    pricings,
    thumbnail: '/_nuxt3-static/promo-cards/giftbox.webp',
    quantity: 1,
    giftcardId: id || 'giftcard',
    ...(supplierId && { supplierId }),
    supplier: supplierName,
  }
}

export default parseGiftcardWithoutEvent
